<!--CAP-26096_POUDG-8493_Lot-2: Added new component -->
<div class="logo header">PORTFOLIO</div>
<div *ngIf="isARLanguage" dir="rtl" style="text-align: center">
    <p>{{'dpo.i18n.subscription.static.msg' | translate}}</p>
    <p>{{'dpo.i18n.subscription.static.msg1' | translate}}</p>
</div>
<div *ngIf="isOtherLanguage" style="text-align: center">
    <p>{{'dpo.i18n.subscription.static.msg' | translate}}</p>
    <p>{{'dpo.i18n.subscription.static.msg1' | translate}}</p>
</div>
